import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: '¡Para nada! El programa está diseñado desde cero. Te enseñamos cada paso, desde cómo preparar tu espacio de trabajo hasta el acabado final.'
  }, {
    q: '¿Los materiales son caros o difíciles de conseguir?',
    a: 'No. Utilizamos cemento común, arena y materiales que puedes encontrar en cualquier ferretería local a un costo muy bajo.'
  }, {
    q: '¿Cómo accedo al curso?',
    a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con tus datos de acceso a nuestra plataforma privada, donde podrás ver los videos cuando quieras.'
  }, {
    q: '¿Por cuánto tiempo tengo acceso?',
    a: 'El acceso es de por vida. Pagas una sola vez y puedes ver las clases todas las veces que necesites, incluyendo futuras actualizaciones.'
  }, {
    q: '¿Qué pasa si tengo dudas durante el proceso?',
    a: 'Tendrás acceso a la sección de comentarios debajo de cada clase donde responderemos todas tus consultas para que nunca te quedes atascada.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-24 bg-sand-50 bg-terrazzo" data-id="element-143">
      <div className="container mx-auto px-4" data-id="element-144">
        <div className="max-w-3xl mx-auto" data-id="element-145">
          <div className="text-center mb-16" data-id="element-146">
            <span className="text-terracotta-500 text-xs font-bold tracking-widest uppercase mb-4 block" data-id="element-147">
              Dudas Comunes
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-concrete-900" data-id="element-148">
              Preguntas Frecuentes
            </h2>
          </div>

          <div className="space-y-4" data-id="element-149">
            {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-sand-200 overflow-hidden transition-all duration-300 hover:shadow-sm" data-id="element-150">
                <button className="w-full px-6 md:px-8 py-6 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-151">
                  <span className="font-medium text-concrete-800 text-base md:text-lg pr-4 font-heading" data-id="element-152">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 flex-shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-153" />
                </button>

                <div className={`px-6 md:px-8 overflow-hidden transition-all duration-500 ease-in-out ${openIdx === idx ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-154">
                  <p className="text-concrete-600 font-light leading-relaxed" data-id="element-155">
                    {faq.a}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}